// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5x-6";
export var headerCell = "_5x-2";
export var rowWrapper = "_5x-4";
export var stickyAggregationCell = "_5x-a";
export var stickyAggregationRow = "_5x-7";
export var stickyColumnCell = "_5x-9";
export var stickyColumnHeaderCell = "_5x-8";
export var table = "_5x-1";
export var virtualRowWrapper = "_5x-5";
export var virtualTableContainer = "_5x-0";
export var white = "_5x-3";